import React, { useState, useEffect } from "react";

const RunbookConclusion = ({conclusion, editable, sendConclusionToParent}) => {
  const [localConclusion, setLocalConclusion] = useState("");

  useEffect(() => {
    setLocalConclusion(conclusion);
  }, [conclusion]);

  const handleChange = (e) => {
    setLocalConclusion(e.target.value);
  }

  const handleSave = () => {
    sendConclusionToParent(localConclusion);
  }

  return(
    <React.Fragment>
      {!editable ?
        <p className="text-start my-4" style={{color:"#DBE1F5", fontSize:"14px"}}>{conclusion}</p>:
        <textarea
          className="form-control"
          value={localConclusion}
          onChange={handleChange}
          onBlur={handleSave}
          style={{ color: "#DBE1F5", fontSize: "14px", width: "100%", minHeight: "50px" }}
        />
      }
    </React.Fragment>
  );

}

export default RunbookConclusion;